module.exports = __webpack_public_path__ + "img/photo-11.a270fcbc.jpg";